import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "./footer"

const Layout = ({ children }) => {
  const header = (
    <div className="w-4/5 m-auto">
      <h1 className="w-auto h-16">
        <Link to="/" className="flex items-center">
          <StaticImage
            height={64}
            src="../images/logo.png"
            alt="ポッポテニスメディア"
          />
        </Link>
      </h1>
    </div>
  )

  return (
    <div>
      <header className="shadow-md shadow-grey-500/50">{header}</header>
      <main>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
